// Utilities
import axios from 'axios';

const state = {
  obj: 'working',
  new_document_object: {},
  error: '',

  margin: null,
};

const mutations = {
  SET_NEW_DOCUMENT(state, payload) {
    state.new_document_object = payload;
  },
  Auth_error(state, payload) {
    state.error = "Ce numéro de document n'existe pas";
  },
};

const actions = {
  CallOffer({ commit }, Infos) {
    const datacollect = {
      page: Infos,
    };

    return new Promise((resolve, reject) => {
      axios({
        url: '/api/2H32IYOG34U2GH34UYG4/getcallOffers',
        method: 'POST',
        data: datacollect,
      })
        .then((resp) => {
          resolve(resp);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  createCallOffer({ commit }, Infos) {
    const datacollect = {
      callStatus: Infos,
      callOfferDescription: Infos,
      OpenDate: Infos,
      EstimationPrice: Infos,
      callProvisionary: Infos,
      visiteDate: Infos,
      depotDate: Infos,
    };

    return new Promise((resolve, reject) => {
      axios({
        url: '/api/2H32IYOG34U2GH34UYG4/createCallOffer',
        method: 'POST',
        data: datacollect,
      })
        .then((resp) => {
          resolve(resp);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  deleteCallOffer({ commit }, Infos) {
    const datacollect = {
      _id: Infos._id,
    };

    return new Promise((resolve, reject) => {
      axios({
        url: '/api/2H32IYOG34U2GH34UYG4/deleteCallOffer',
        method: 'POST',
        data: datacollect,
      })
        .then((resp) => {
          resolve(resp);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  updateCallOffer({ commit }, Infos) {
    const datacollect = {
      page: Infos,
    };

    return new Promise((resolve, reject) => {
      axios({
        url: '/api/2H32IYOG34U2GH34UYG4/updateCallOffer',
        method: 'POST',
        data: datacollect,
      })
        .then((resp) => {
          resolve(resp);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  searchCallOffer({ commit }, Infos) {
    const datacollect = {
      page: Infos.page,
      searchData: Infos.searchData,
    };

    return new Promise((resolve, reject) => {
      axios({
        url: '/api/2H32IYOG34U2GH34UYG4/searchCallOffer',
        method: 'POST',
        data: datacollect,
      })
        .then((resp) => {
          resolve(resp);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  IsOpened({ commit }, UpdateInfo) {
    return new Promise((resolve, reject) => {
      axios({
        url: '/api/KLJH24HKK4J324F2F83H/requestopened',
        method: 'POST',
        data: UpdateInfo,
        headers: { Authorization: 'Bearer ' + localStorage.getItem('token') },
      })
        .then((resp) => {
          resolve(resp);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  NewDocumentEditing({ commit }, UpdateInfo) {
    return new Promise((resolve, reject) => {
      axios({
        url: '/api/KLJH24HKK4J324F2F83H/updaterequestdetails',
        method: 'POST',
        data: UpdateInfo,
        headers: { Authorization: 'Bearer ' + localStorage.getItem('token') },
      })
        .then((resp) => {
          resolve(resp);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
};

const getters = {};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
